import { render, staticRenderFns } from "./faith.vue?vue&type=template&id=5914eddb"
import script from "./faith.vue?vue&type=script&lang=js"
export * from "./faith.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports